import React, { useEffect } from 'react';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext as useUsersContext } from 'components/Users/Context';

import Statistics from './Statistics';
import Terms from './Terms';
import Payments from './Payments';

export default function Main() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  return (
    <>
      <div className="content">
        <section>
          <h1>Overview</h1>
        </section>

        <section>
          <Statistics />
        </section>
      </div>

      <div className="content">
        <section>
          <h3>Affiliate Statements</h3>
          <p>
            We issue commission payouts once per quarter, following the complete collection
            of premium payments from the preceding quarter.
          </p>
        </section>

        <section>
          <Payments />
        </section>

        <section>
          {stateUsers.user ? <Terms /> : <LoadingPlaceholder />}
        </section>
      </div>
    </>
  );
}
